import { customerRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useAsync } from "../../components/ui";

// ผูกผู้ใช้ที่ล็อกอินกับแถว customers ของร้านที่เขาสมัครไว้
//   - สมัครผ่านลิงก์ร้าน -> profile.customerId ชี้แถวของตัวเองตรง ๆ
//   - แอดมินที่กดดูฝั่งลูกค้า -> fallback เป็นลูกค้าคนแรกของร้านตัวเอง (โหมดสาธิต)
//   - บัญชีลูกค้าที่ยังไม่ผูก customerId -> ไม่มีข้อมูล (null) ห้าม fallback ไปคนอื่น เสี่ยงเห็นบิล/ใบกำกับของลูกค้าคนอื่น
export const useMockCustomer = (orgId) => {
  const { customerId, isAdmin } = useApp();

  const { data, loading } = useAsync(
    async () => {
      if (customerId) {
        const mine = await customerRepo.get(orgId, customerId);
        if (mine && mine.id === customerId) return mine;
      }
      if (!isAdmin) return null;
      const rows = await customerRepo.all(orgId);
      return rows?.[0] || null;
    },
    [orgId, customerId, isAdmin],
    null
  );

  return { customer: data || null, loading };
};
